module.exports = "<div class=\"weui_tabbar\">\n  <slot></slot>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tab/tabbar.vue
 ** module id = 142
 ** module chunks = 0
 **/